import React from 'react';

interface TimelineStep {
    title: string;
    description?: string;
}

interface TimelineProps {
    heading: string;
    subtitle?: string;
    steps: TimelineStep[];
}

const Timeline: React.FC<TimelineProps> = ({ heading, subtitle, steps }) => {
    return (
        <section className="bg-secondaryLight py-12 px-4">
            <div className="max-w-4xl mx-auto">
                {heading && (
                    <h3 className="text-3xl sm:text-4xl font-semibold text-center text-textColor mb-8">
                        {heading}
                    </h3>
                )}

                {subtitle && (
                    <h3 className="text-gray-700 text-lg"
                        dangerouslySetInnerHTML={{ __html: subtitle }}>
                    </h3>
                )}

                <ol className="space-y-6">
                    {steps.map((step, idx) => (
                        <li key={idx} className="flex items-center gap-4">
                            <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-primary text-xl font-bold text-textColor">
                                {idx + 1}.
                            </span>

                            <div className="flex-1 bg-white p-4 rounded-xl shadow-md border border-lineGreen/30">
                                <h3 className="text-xl font-semibold text-textColor mb-2">
                                    {step.title}
                                </h3>
                                {step.description && (
                                    <p className="text-gray-700 text-sm">{step.description}</p>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default Timeline;
